import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import styled from "styled-components";
import ContactImg1 from "../../assets/img/use7.jpg";
import ContactImg2 from "../../assets/img/use5.jpeg";

export default function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("idle");

  const sendEmail = (event) => {
    event.preventDefault();
    setStatus("sending");
    emailjs.sendForm("service_z81wd5m", "template_eadrn6f", form.current, "MrF5O3hzkcV2541pp")
      .then(() => { setStatus("sent"); form.current.reset(); })
      .catch(() => setStatus("error"));
  };

  return (
    <Wrapper id="contact">
      <div className="container">
        <HeaderInfo>
          <div><p className="section-kicker">Let’s build what’s next</p><h2 className="font40 extraBold">Connect with us</h2></div>
          <p>Would you like to know more about us, or are you ready to take your business to the next level?</p>
        </HeaderInfo>
        <ContactGrid>
          <FormCard>
            <Form ref={form} onSubmit={sendEmail}>
              <FieldRow>
                <Field><label htmlFor="fname">First name</label><input required type="text" id="fname" name="user_name" placeholder="Your name" /></Field>
                <Field><label htmlFor="email">Email address</label><input required type="email" id="email" name="user_email" placeholder="you@company.com" /></Field>
              </FieldRow>
              <Field><label htmlFor="subject">Subject</label><input required type="text" id="subject" name="subject" placeholder="How can we help?" /></Field>
              <Field><label htmlFor="message">Message</label><textarea required rows="5" id="message" name="message" placeholder="Tell us a little about your project or requirement" /></Field>
              <FormFooter>
                <Submit type="submit" disabled={status === "sending"}>{status === "sending" ? "Sending…" : "Send message"}<span aria-hidden="true">↗</span></Submit>
                <Status aria-live="polite" $error={status === "error"}>{status === "sent" ? "Thank you — your message has been sent." : status === "error" ? "Something went wrong. Please try again or call us." : ""}</Status>
              </FormFooter>
            </Form>
          </FormCard>
          <ContactVisual>
            <img src={ContactImg1} alt="Omnicom telecom engineer" />
            <SmallPhoto src={ContactImg2} alt="Omnicom Solutions operations" />
            <ContactDetails>
              <small>Our Lagos office</small>
              <p>15, Bola Sonoiki Street,<br />Ramat Crescent, Ogudu GRA,<br />Lagos, Nigeria.</p>
              <a href="tel:+2347015999310">+234 701 5999 310</a>
            </ContactDetails>
          </ContactVisual>
        </ContactGrid>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`padding: 120px 0 130px; background: #fff; @media (max-width: 700px) { padding: 80px 0 90px; }`;
const HeaderInfo = styled.div`
  display: grid; grid-template-columns: 1fr .7fr; gap: 80px; align-items: end; margin-bottom: 50px;
  h2 { color: #17152f; } > p { color: #626878; font-size: .92rem; }
  @media (max-width: 760px) { grid-template-columns: 1fr; gap: 18px; }
`;
const ContactGrid = styled.div`display: grid; grid-template-columns: 1fr .85fr; gap: 22px; @media (max-width: 880px) { grid-template-columns: 1fr; }`;
const FormCard = styled.div`padding: 38px; border: 1px solid #e3e7e5; border-radius: 28px; background: #f8faf9; @media (max-width: 520px) { padding: 24px 18px; }`;
const Form = styled.form`display: flex; flex-direction: column; gap: 24px;`;
const FieldRow = styled.div`display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; @media (max-width: 540px) { grid-template-columns: 1fr; gap: 24px; }`;
const Field = styled.div`
  label { display: block; margin-bottom: 8px; color: #343746; font-size: .72rem; font-weight: 800; }
  input, textarea { width: 100%; padding: 15px 16px; border: 1px solid #dfe3e1; border-radius: 12px; background: #fff; color: #17152f; outline: none; font-size: .85rem; resize: vertical; transition: .2s ease; }
  input::placeholder, textarea::placeholder { color: #a4a8b0; }
  input:focus, textarea:focus { border-color: #0a9250; box-shadow: 0 0 0 4px rgba(10,146,80,.09); }
`;
const FormFooter = styled.div`display: flex; align-items: center; gap: 18px; flex-wrap: wrap;`;
const Submit = styled.button`display: inline-flex; align-items: center; gap: 12px; padding: 14px 24px; border: 0; border-radius: 999px; background: #0a9250; color: #fff; font-size: .82rem; font-weight: 800; cursor: pointer; box-shadow: 0 14px 30px rgba(10,146,80,.2); &:hover { background: #077d44; transform: translateY(-2px); } &:disabled { opacity: .65; cursor: wait; }`;
const Status = styled.p`color: ${({ $error }) => ($error ? "#b42318" : "#0a9250")}; font-size: .76rem; font-weight: 700;`;
const ContactVisual = styled.div`
  position: relative; min-height: 575px; overflow: hidden; border-radius: 28px; background: #17152f;
  > img:first-child { width: 100%; height: 100%; object-fit: cover; opacity: .88; }
  &::after { content: ""; position: absolute; inset: 0; background: linear-gradient(180deg, transparent 35%, rgba(23,21,47,.72)); }
  @media (max-width: 520px) { min-height: 530px; }
`;
const SmallPhoto = styled.img`position: absolute; z-index: 2; top: 22px; right: 22px; width: 120px !important; height: 150px !important; border: 5px solid rgba(255,255,255,.9); border-radius: 18px; object-fit: cover; opacity: 1 !important;`;
const ContactDetails = styled.div`
  position: absolute; z-index: 2; left: 30px; right: 30px; bottom: 28px; padding: 24px; border: 1px solid rgba(255,255,255,.16); border-radius: 20px; background: rgba(23,21,47,.78); color: #fff; backdrop-filter: blur(14px);
  small { color: #a8cf45; font-size: .65rem; font-weight: 800; letter-spacing: .13em; text-transform: uppercase; }
  p { margin: 10px 0 14px; color: rgba(255,255,255,.74); font-size: .8rem; line-height: 1.7; }
  a { color: #fff; font-size: .86rem; font-weight: 800; }
  a:hover { color: #a8cf45; }
`;
